import helper from "actions/helper";

export default function ReportSalaryDetails(items, validity, currentSecondText, itemsSalaryDetailsToplam) {
    if (!items || items.length < 1)
        return false;

    const style = [{
        name: "wrapText",
        start: [1, 1],
        end: [1, 1]
    }, {
        name: "border",
        start: [3, 1],
        end: [3, 3]
    }, {
        name: "bold",
        start: [1, 1],
        end: [1, 8]
    }];

    const width = [
        { key: 'A', width: 20 },
        { key: 'B', width: 20 },
        { key: 'C', width: 20 },
        { key: 'D', width: 20 },
        { key: 'E', width: 20 },
        { key: 'F', width: 20 },
    ];

    const text = [
        [`Отчет сформирован за период с ${validity} ${currentSecondText}`],
        ["Пациент", "Номер счета", "Дата", "Выставлено по счету", "Дата оплаты", "Оплачено по счету", "Материалы", "Рентген", "К оплате", "Статус"]
    ];

    items.forEach(it => {
        const { patient, invoiceId, invoiceAmount, paid, materials, rentgen, invoiceDate, lastPayDate, status } = it;

        text.push([
            patient,
            invoiceId,
            invoiceDate,
            invoiceAmount,
            lastPayDate,
            paid,
            materials,
            rentgen,
            paid - materials,
            status === "CANCELLED" ? "отменен" : ""
        ]);
    });
    const { invoiceAmount, paid, materials, rentgen, toplam } = itemsSalaryDetailsToplam;
    text.push(["Итого", "", "", invoiceAmount, "", paid, materials, rentgen, toplam]);

    style.push({
        name: "bold",
        start: [text.length, 1],
        end: [text.length, 8]
    });

    const merges = [
        { start: [1, 1], end: [1, 8] }
    ];

    const data = { text, style, width, merges };

    helper.xlsx.exportToExcel(data, "ReportSalary.xlsx");

}
